import Component from '@glimmer/component';

import { array } from '@ember/helper';
import { service } from '@ember/service';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import Items from 'rise-ui/components/time-series/selection/items.gjs';
import Record from 'rise-ui/components/time-series/selection/line/record.gjs';
import notIn from 'rise-ui/helpers/not-in.js';
import recordsWithResult from 'rise-ui/helpers/records-with-result.js';
import sticky from 'rise-ui/modifiers/sticky.js';

export default class TimeSeriesSelectionRecordsComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;

  <template>
    {{#each (recordsWithResult @location.validCatalogRecords) as | record |}}
      {{#if (notIn this.selectedLocations.hidden.records record.id)}}
        <Sticky @name="record">
          <div class="c-sticky-subtitle">Catalog Record</div>
          <div class="c-time-series-selection-line__label">
            {{~#if record.generationEffort}}
              {{~record.generationEffort~}}
            {{~else~}}
              {{record.title}}
            {{~/if~}}
          </div>
        </Sticky>
        <ExpandingBlock
          @button={{true}}
          @initExpanded={{true}}
          @iconClass="c-time-series-selection-line__expander c-time-series-selection-line-catalog__expander"
        >
          <:head>
            <Record
              @linkToCatalog={{array "catalog.record" record.id}}
              @record={{record}}
              @abbrNeedle={{@location.name}}
              {{sticky activate="location record"}}
            />
          </:head>
          <:body>
            <Items
              @items={{record.validItems}}
              @hasItem={{@hasItem}}
              @isValidItem={{@isValidItem}}
              @itemDates={{@itemDates}}
              @hasModelRun={{@hasModelRun}}
              @isValidModelRun={{@isValidModelRun}}
              @modelRunDates={{@modelRunDates}}
            />
          </:body>
        </ExpandingBlock>
      {{/if}}
    {{/each}}
  </template>
}
